import React, {Component} from "react";
import PropTypes from "prop-types";
import {Card} from "react-bootstrap";
import "../Elements/FromGroup/form_select.css"
import AscModal from "../Elements/Modal/Modal";
import {EditCategoryTitle, EditCategoryExplanation, EditCategoryRgb, 
    EditCategoryFontRgb, ViewCategoryImage} from "../Elements/AscElements/CategoryElements";

export default class CategoryUpdateModal extends Component {

    render() {
        return (
            <AscModal
                state={this.props.state}
                propSetState={this.props.propSetState}
                langText={this.props.langText}
                validationHandle={this.props.validationHandle}
                onClick={this.props.onClick}>
                <Card variant="info">
                    <Card.Header>
                        <Card.Title>
                            {this.props.langText.Body.CategoryInfo}
                        </Card.Title>
                    </Card.Header>

                    <Card.Body>
                        <EditCategoryTitle
                            state={this.props.state}
                            langText={this.props.langText}
                            onTextChange_Limit = {this.props.onTextChange_Limit}
                            charaLimit = {this.props.charaLimit}>
                        </EditCategoryTitle>
                        <EditCategoryExplanation
                            state={this.props.state}
                            langText={this.props.langText}
                            onTextChange_Limit = {this.props.onTextChange_Limit}
                            charaLimit = {this.props.charaLimit}>
                        </EditCategoryExplanation>
                        <EditCategoryRgb
                            state={this.props.state}
                            propSetState={this.props.propSetState}
                            langText={this.props.langText}
                            onTextChange_Limit = {this.props.onTextChange_Limit}
                            charaLimit = {this.props.charaLimit}>
                        </EditCategoryRgb>
                        <EditCategoryFontRgb
                            state={this.props.state}
                            propSetState={this.props.propSetState}
                            langText={this.props.langText}
                            onTextChange_Limit = {this.props.onTextChange_Limit}
                            charaLimit = {this.props.charaLimit}>
                        </EditCategoryFontRgb>
                        <ViewCategoryImage
                            state={this.props.state}
                            langText={this.props.langText}>
                        </ViewCategoryImage>
                    </Card.Body>
                </Card>
            </AscModal>
        );
    }
}

CategoryUpdateModal.propTypes = {
    state: PropTypes.object.isRequired,
    langText: PropTypes.object.isRequired,
    charaLimit: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    validationHandle: PropTypes.func.isRequired,
    onTextChange_Limit: PropTypes.func.isRequired,
    propSetState: PropTypes.func,
};
